import { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, EmptyState } from "../components/Section";

export default function Ministries() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/ministries").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="ministries-page">
      <PageHeader eyebrow="SERVICE & DISCIPLESHIP" title="Ministries"
        subtitle="Every member has a place to serve. Explore the arms of the Council." />
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          {items.length === 0 ? <EmptyState /> : (
            <div className="grid grid-cols-12 gap-6">
              {items.map((m, i) => (
                <article key={m.id} data-testid={`ministry-${m.id}`} className={`col-span-12 md:col-span-6 ${i % 3 === 0 ? "lg:col-span-8" : "lg:col-span-4"} border hairline rounded-xl overflow-hidden surface group hover:border-gold/50 transition-colors duration-300`}>
                  {m.image_url && <div className="aspect-[16/9] overflow-hidden"><img src={m.image_url} alt={m.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>}
                  <div className="p-7">
                    <h3 className="font-display text-2xl text-white">{m.name}</h3>
                    <p className="mt-1 font-accent text-[10px] text-gold">{m.leader}</p>
                    <p className="mt-4 text-zinc-400 leading-relaxed">{m.description}</p>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
